import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { authApi } from '../store/auth/authApi';
import { userAPI } from '../store/user/userApi';
import { userDomAPI } from '../store/user/userDomApi';
import teamsSlice from '../store/brokers/partners/teams/teamsSlice';
import partnersSlice from '../store/brokers/partners/partners/partnersSlice';
import documentsSlice from '../store/brokers/partners/documents/documentsSlice';
import activitiesSlice from '../store/brokers/partners/activities/activititesSlice';
import historyChatsSlice from '../store/brokers/partners/history-chats/historyChatsSlice';
import userAccessSlice from '../store/brokers/partners/user-access-control/userAccessSlice';
import notificationsSlice from '../store/brokers/partners/notifications/notificationsSlice';
import knowledgeFilesSlice from '../store/brokers/partners/knowledge-files/knowledgeFilesSlice';
import questionsSlice from '../store/brokers/partners/unanswered-questions/unansweredQuestionsSlice';
import chatsSlice from '../store/slices/chats.slice';
import { chatboxApi } from '../store/chatbox/chatboxApi';
import chatsUISlice from '../store/brokers/partners/chats/ChatsUISlice';
import transactionsSlice from '../store/brokers/partners/transactions/transactionsSlice';
import adminSlice from '../store/brokers/partners/admin/adminSlice';


export const store = configureStore({
    reducer: {
        [userAPI.reducerPath]: userAPI.reducer,
        [authApi.reducerPath]: authApi.reducer,
        [userDomAPI.reducerPath]: userDomAPI.reducer,
        [chatboxApi.reducerPath]: chatboxApi.reducer,
        userAccess: userAccessSlice,
        partners: partnersSlice,
        history: historyChatsSlice,
        teams: teamsSlice,
        notifications: notificationsSlice,
        activities: activitiesSlice,
        questions: questionsSlice,
        documents: documentsSlice,
        knowledgeFiles: knowledgeFilesSlice,
        chats: chatsSlice,
        chatUi: chatsUISlice,
        transactions: transactionsSlice,
        admin: adminSlice
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            userAPI.middleware,
            authApi.middleware,
            userDomAPI.middleware,
            chatboxApi.middleware
        ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
